import { IContext, rehydrate } from 'overmind';
import { namespaced, merge } from 'overmind/config';
import {
  createStateHook,
  createActionsHook,
  createEffectsHook,
  createReactionHook,
} from 'overmind-react';

// namespaced state and actions
import * as app from './namespaces/app';
import * as continueWatching from './namespaces/continue-watching';
import * as favourites from './namespaces/favourites';
import * as player from './namespaces/player';
import * as playerV2 from './namespaces/playerv2';
import * as search from './namespaces/search';
import * as session from './namespaces/session';
import * as teaserDetails from './namespaces/teaser-details';
import * as user from './namespaces/user';
import * as parentalControlSetup from './namespaces/parental-control-setup';

export const config = merge(
  {
    actions: {
      changePage({ state }, mutations) {
        rehydrate(state, mutations || []);
      },
    },
  },
  namespaced({
    user,
    session,
    favourites,
    player,
    playerV2,
    app,
    search,
    teaserDetails,
    continueWatching,
    parentalControlSetup,
  })
);
export type Context = IContext<{
  state: typeof config.state;
  actions: typeof config.actions;
  effects: typeof config.effects;
}>;

export const useOvermindState = createStateHook<Context>();
export const useOvermindActions = createActionsHook<Context>();
export const useOvermindEffects = createEffectsHook<Context>();
export const useOvermindReaction = createReactionHook<Context>();
